import React, { useEffect, useState } from 'react'
import { compare, formatCash } from 'utils'
import moment from 'moment'

//components
import TitlePage from 'components/title-page'

//antd
import {
  Button,
  Row,
  Table,
  Switch,
  notification,
  Form,
  InputNumber,
  Input,
  Modal,
  Popconfirm,
  Space,
  Select,
  Typography,
} from 'antd'

//icons
import {
  DeleteOutlined,
  EditOutlined,
  LoadingOutlined,
  PlusCircleOutlined,
  PlusOutlined,
} from '@ant-design/icons'
import { getCountries } from 'apis/country'
//apis
import {
  getProductType,
  createProductType,
  deleteProductType,
  updateProductType,
} from 'apis/product'

export default function ProductType() {
  const [form] = Form.useForm()

  const [productTypes, setProductTypes] = useState([])
  const [countries, setCountries] = useState([])
  const [countProductType, setCountProductType] = useState(0)
  const [paramsFilter, setParamsFilter] = useState({ page: 1, page_size: 20 })
  const [record, setRecord] = useState(null)
  const [btnLoading, setBtnLoading] = useState(false)
  const [tableLoading, setTableLoading] = useState(false)
  const [toppingCategoryList, setToppingCategoryList] = useState([])
  const [loading, setLoading] = useState(false)
  const [nameToppingCategory, setNameToppingCategory] = useState('')

  const [visible, setVisible] = useState(false)
  const toggle = () => setVisible(!visible)

  const _getProductTypeList = async () => {
    try {
      setTableLoading(true)
      const res = await getProductType({ ...paramsFilter })
      if (res.status === 200) {
        setProductTypes(res.data.data)
        setCountProductType(res.data.count)
      }
      setTableLoading(false)
    } catch (err) {
      setTableLoading(false)
      console.log(err)
    }
  }

  const _getCountries = async () => {
    try {
      const res = await getCountries()
      if (res.status === 200) setCountries(res.data.data)
    } catch (error) {
      console.log(error)
    }
  }

  const _updateProductType = async (body, id) => {
    try {
      setTableLoading(true)
      const res = await updateProductType(id, body)
      if (res.status === 200) {
        if (res.data.success) {
          notification.success({ message: 'Cập nhật thành công' })
          _getProductTypeList()
        } else
          notification.error({
            message: res.data.message || 'Cập nhật không thành công, vui lòng thử lại',
          })
      } else
        notification.error({
          message: res.data.message || 'Cập nhật không thành công, vui lòng thử lại',
        })
      setTableLoading(false)
    } catch (error) {
      setTableLoading(false)
    }
  }

  const _onDeleteProductType = async (id) => {
    try {
      const res = await deleteProductType(id)
      if (res.status === 200) {
        notification.success({ message: 'Xóa thành công' })
        _getProductTypeList()
      } else {
        notification.error({ message: res.data.message || 'Xóa không thành công' })
      }
    } catch (err) {
      console.log(err)
      notification.error({ message: 'Xóa topping không thành công!' })
    }
  }
  const columns = [
    {
      title: 'STT',
      render(data, record, index) {
        return (paramsFilter.page - 1) * paramsFilter.page_size + index + 1
      },
    },
    {
      title: 'Quốc gia',
      dataIndex: 'country_info',
      render(data, record, index) {
        return <div>{record.country_info && record.country_info.name}</div>
      },
    },
    {
      title: 'Mã',
      dataIndex: 'code',
      sorter: (a, b) => compare(a, b, 'code'),
    },
    {
      title: 'Tên cách nấu',
      dataIndex: 'name',
      sorter: (a, b) => compare(a, b, 'name'),
    },
    {
      title: 'Mô tả',
      dataIndex: 'description',
      sorter: (a, b) => compare(a, b, 'description'),
    },
    // {
    //   title: 'Loại topping',
    //   render: (text, record) =>
    //     record.topping_category_info &&
    //     record.topping_category_info.map((topping) => topping.name).join(', '),
    // },
    // {
    //   title: 'Giá',
    //   dataIndex: 'price',
    //   sorter: (a, b) => compare(a, b, 'price'),
    //   render(data) {
    //     return formatCash(data || 0)
    //   },
    // },
    {
      title: 'Ngày tạo',
      dataIndex: 'create_date',
      render(data) {
        return data && moment(data).format('DD/MM/YYYY HH:mm')
      },
    },
    {
      title: 'Hành động',
      render(data, record) {
        return (
          <Space size="middle">
            {/* <Switch
              checked={record.is_active}
              onClick={() =>
                _updateProductType({ is_active: !record.is_active }, record.topping_id)
              }
            /> */}

            <EditOutlined
              onClick={() => {
                setRecord(record)
                toggle()
              }}
              style={{ color: 'blue', cursor: 'pointer', fontSize: 17 }}
            />

            <Popconfirm
              title="Bạn muốn xóa record này không?"
              okText="Xác nhận"
              cancelText="Hủy"
              onConfirm={() => _onDeleteProductType(data.product_type_id)}
            >
              <DeleteOutlined style={{ color: 'red', cursor: 'pointer', fontSize: 17 }} />
            </Popconfirm>
          </Space>
        )
      },
    },
  ]

  const _addOrUpdateTopping = async (formData) => {
    try {
      setBtnLoading(true)
      let res
      const body = { ...formData }
      if (record) res = await updateProductType(record.topping_id, body)
      else res = await createProductType(body)

      if (res.status === 200) {
        if (res.data.success) {
          notification.success({ message: `${record ? 'Cập nhật' : 'Thêm'}  thành công` })
          _getProductTypeList()
          form.resetFields()
          toggle()
        } else
          notification.error({
            message: res.data.message || `${record ? 'Cập nhật' : 'Thêm'}  không thành công`,
          })
      } else
        notification.error({
          message: res.data.message || `${record ? 'Cập nhật' : 'Thêm'} topping không thành công`,
        })
      setBtnLoading(false)
    } catch (err) {
      console.log(err)
      setBtnLoading(false)
    }
  }

  useEffect(() => {
    if (visible) {
      if (record) form.setFieldsValue({ ...record })
    } else form.resetFields()
  }, [visible])

  useEffect(() => {
    _getCountries()
  }, [])

  useEffect(() => {
    _getProductTypeList()
  }, [paramsFilter])

  return (
    <div
      style={{
        boxShadow: ' 0 12px 23px 0 #5c37990a',
        borderRadius: '1.25rem',
        background: '#fff',
        margin: '1rem',
        padding: '1rem',
      }}
    >
      <Modal
        title={record ? 'Cập nhật' : 'Thêm'}
        visible={visible}
        onCancel={toggle}
        footer={false}
        width="60%"
      >
        <Form
          onFinish={_addOrUpdateTopping}
          form={form}
          labelCol={{ span: 5 }}
          wrapperCol={{ span: 19 }}
          labelAlign="left"
        >
          <Form.Item
            name="country_id"
            label="Quốc gia"
            rules={[{ required: true, message: 'Vui lòng chọn quốc gia' }]}
          >
            <Select placeholder="Chọn quốc gia" optionFilterProp="children" showSearch>
              {countries.map((country, index) => (
                <Select.Option value={country.country_id} key={index}>
                  {country.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="name"
            label="Tên cách nấu"
            rules={[{ required: true, message: 'Vui lòng nhập tên topping' }]}
          >
            <Input placeholder="Nhập tên topping" />
          </Form.Item>

          <Form.Item name="description" label="Mô tả">
            <Input placeholder="Nhập mô tả" />
          </Form.Item>

          {/* <Form.Item
            name="price"
            label="Giá"
            rules={[{ required: true, message: 'Vui lòng nhập giá' }]}
          >
            <InputNumber
              min={0}
              placeholder="Nhập giá topping"
              style={{ width: '100%' }}
              formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
              parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
            />
          </Form.Item> */}

          <Row justify="end">
            <Button type="primary" htmlType="submit" loading={btnLoading}>
              {record ? 'Cập nhật' : 'Thêm'}
            </Button>
          </Row>
        </Form>
      </Modal>

      <TitlePage title="Cách nấu">
        <Button onClick={toggle} size="large" type="primary" icon={<PlusCircleOutlined />}>
          Thêm cách nấu
        </Button>
      </TitlePage>
      <Table
        columns={columns}
        dataSource={productTypes}
        size="small"
        loading={tableLoading}
        pagination={{
          position: ['bottomLeft'],
          current: paramsFilter.page,
          defaultPageSize: 20,
          pageSizeOptions: [20, 30, 40, 50, 60, 70, 80, 90, 100],
          showQuickJumper: true,
          onChange: (page, pageSize) =>
            setParamsFilter({ ...paramsFilter, page: page, page_size: pageSize }),
          total: countProductType,
        }}
      />
    </div>
  )
}
